import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getPagePath, trans } from '@spotahome/soyuz/client';

import Link from '../Link';

import ChevronDown from '../icons/ChevronDown';
import ChevronUp from '../icons/ChevronUp';

import styles from './CityList.module.scss';

const CityList = ({
  cities,
  collapsible = true,
  titleKey = 'landingpage.othercities.title'
}) => {
  const [isMoreShown, setIsMoreShown] = useState(true);
  const listHeader = useRef(null);

  const cityListClassNames = classNames(styles['city-list'], {
    [styles['city-list--redesign']]: !isMoreShown
  });

  const toggleClickHandler = () => {
    if (!collapsible) {
      return;
    }

    setIsMoreShown(!isMoreShown);
    if (isMoreShown) {
      listHeader.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const titleContainerClassNames = classNames(
    styles['city-list__title-container'],
    {
      [styles['city-list__title-container--clickable']]: collapsible
    }
  );

  return (
    <div className={styles['city-list__wrapper']}>
      <div
        className={titleContainerClassNames}
        tabIndex={0}
        role="button"
        onClick={toggleClickHandler}
      >
        <h2 className={styles['city-list__title']} ref={listHeader}>
          {trans(titleKey)}
        </h2>
        {collapsible && (
          <div
            className={classNames(
              styles['city-list__show-button-chevron'],
              styles['city-list__show-button-chevron-title']
            )}
          >
            {isMoreShown ? <ChevronDown /> : <ChevronUp />}
          </div>
        )}
      </div>

      {isMoreShown && (
        <>
          <div className={cityListClassNames}>
            {cities.map(city => (
              <Link
                key={city.id}
                href={getPagePath('marketplace.free-search', {
                  params: { locationString: city.id }
                })}
              >
                {city.cityName}
              </Link>
            ))}
          </div>
          {collapsible && (
            <div
              role="button"
              tabIndex={0}
              className={styles['city-list__show-button--mobile']}
              onClick={toggleClickHandler}
            >
              {trans('landingpage.othercities.show-less')}
              <span className={styles['city-list__show-button-chevron']}>
                <ChevronUp />
              </span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

CityList.propTypes = {
  cities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      cityName: PropTypes.string
    })
  ).isRequired,
  collapsible: PropTypes.bool,
  titleKey: PropTypes.string
};

export default CityList;
